// extracted by mini-css-extract-plugin
module.exports = {"content":"WorkType_content__1r8bn","submitBtn":"WorkType_submitBtn__Iq7pi"};